module.exports = __webpack_public_path__ + "static/media/book-who-is-nemos-detail5.9a189b3d.jpg";